// extracted by mini-css-extract-plugin
module.exports = {"row":"Game_row__21yo6","heading":"Game_heading__C5H_m"};